import { RadioGroup } from '@madpaws/design-system';
import React from 'react';

import { DOG_GROOMING_SERVICE_ID, DOG_TRAINING_SERVICE_ID } from '~/common/constants/app';
import { SERVICE_OPTIONS_DAYTIME, SERVICE_OPTIONS_OVERNIGHT } from '~/components/constants';

import styles from './ExpandedServiceTypeSelector.module.css';

import type { RadioGroupOnChange } from '@madpaws/design-system';
import type { ReactElement } from 'react';

type Props = {
  isLegendVisuallyHidden?: boolean;
  name: string;
  onChange: (event: RadioGroupOnChange) => void;
  value: string;
};

const SERVICE_OPTIONS_DAYTIME_TRIMMED = SERVICE_OPTIONS_DAYTIME.filter(
  (service) =>
    service.serviceTypeId !== DOG_GROOMING_SERVICE_ID &&
    service.serviceTypeId !== DOG_TRAINING_SERVICE_ID
);

export const ExpandedServiceTypeSelector = ({
  onChange,
  isLegendVisuallyHidden,
  name,
  value,
}: Props): ReactElement => (
  <div className={styles.root}>
    <RadioGroup
      isLegendVisuallyHidden={isLegendVisuallyHidden}
      isTileWithImageCompressed
      legend="Overnight services"
      name={name}
      onChange={onChange}
      options={SERVICE_OPTIONS_OVERNIGHT}
      value={{ value }}
      variant="tiledWithImage"
    />
    <RadioGroup
      isLegendVisuallyHidden={isLegendVisuallyHidden}
      isTileWithImageCompressed
      legend="Daytime services"
      name={name}
      onChange={onChange}
      options={SERVICE_OPTIONS_DAYTIME_TRIMMED}
      value={{ value }}
      variant="tiledWithImage"
    />
  </div>
);
